import { render, staticRenderFns } from "./MoleculeEditionAccountNotificationsConfiguration.vue?vue&type=template&id=57a46484"
import script from "./MoleculeEditionAccountNotificationsConfiguration.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionAccountNotificationsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports